"use strict";Object.defineProperty(exports, "__esModule", {value: true});/* Inputs in the recipients table aren't credentials: keep password managers
 * (1Password, LastPass) from decorating or filling them (Rev 17). */
 const NO_AUTOFILL = {
  autoComplete: 'off',
  'data-1p-ignore': true,
  'data-lpignore': 'true',
  'data-form-type': 'other',
} ; exports.NO_AUTOFILL = NO_AUTOFILL
